import React from 'react';

const styles = {
    container: {
        width: '95%',
        margin: '0 auto 40px auto',
        display: 'flex',
        flexDirection: 'row'
    }
};

/**
 *
 * @param {*} param0
 */
const CoverageBlock = ({ children }) => (
    <div style={ styles.container }>
        { children }
    </div>
);

export default (CoverageBlock);